import { createSaga } from './saga-helpers';

import * as Api from '../api/connected-accounts-api';

const watchGetConnectedAccounts = createSaga({
    type: 'CONNECTED_ACCOUNTS_FETCH',
    fn: Api.fetchConnectedAccounts,
    args: action => [action.payload],
    successPayload: ({ linked_accounts }, action) => ({
        items: linked_accounts,
        ...action.payload
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        ...action.payload
    })
});

const watchCreateConnectedAccount = createSaga({
    type: 'CONNECTED_ACCOUNT_CREATE',
    fn: Api.createConnectedAccount,
    args: action => [action.payload.connectedAccount],
    successPayload: ({ id: connectedAccountId, name: connectedAccountName }, action) => ({
        connectedAccountId,
        connectedAccountName,
        fragment: action.payload.connectedAccount
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        fragment: action.payload.connectedAccount
    })
});

const watchRemoveConnectedAccount = createSaga({
    type: 'CONNECTED_ACCOUNT_REMOVE',
    fn: Api.removeConnectedAccount,
    args: action => [action.payload]
});

const sagas = [watchGetConnectedAccounts, watchCreateConnectedAccount, watchRemoveConnectedAccount];

export default sagas;
